export enum example {
    example = "example"
}

export enum LanguagesEnum {
    EN = 'en',
    AR = 'ar',
  }